import { darken, makeStyles, Theme } from '@material-ui/core';
import { isDarkTheme } from '../../eliot-components/src/theme';

export const useDesktopLayoutStyles = makeStyles((theme: Theme) => ({
  selected: {
    backgroundColor: theme.palette.action.hover,
  },
  targetSystems: {
    tableLayout: 'fixed',
    '& thead .MuiTableCell-stickyHeader': {
      backgroundColor: isDarkTheme(theme) ? '#393939' : '#eeeeee',
      borderBottom: '2px solid rgba(0,0,0,0.12)',
    },

    '& tbody tr:nth-of-type(even)': {
      backgroundColor: isDarkTheme(theme) ? '#393939' : '#fafafa',
    },
  },
  tsRow: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  sortableCell: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    '&::hover': {
      color: darken(theme.palette.text.secondary, 0.3),
    },
    '& svg': {
      width: '18px',
      height: '18px',
      marginLeft: '7px',
    },
  },
  sortableCenter: {
    justifyContent: 'center',
  },
  breakWord: {
    width: '100%',
    wordWrap: 'break-word',
  },
  container: {
    overflow: 'auto',
    height: 'calc(100vh - 156px)',
  },
  summary: {
    height: '56px',
    paddingRight: theme.spacing(7),
    borderTop: '1px',
    borderColor: theme.palette.text.primary,
    backgroundColor: isDarkTheme(theme)
      ? theme.palette.secondary.main
      : '#eeeeee',
  },
  refresh: {
    position: 'relative',
    textAlign: 'right',
  },
  refreshProgress: {
    padding: theme.spacing(1),
  },
  refreshIcon: {
    display: 'inline-block',
  },
  refreshProgressWrapper: {
    display: 'inline-block',
    width: '40px',
    height: '40px',
    position: 'absolute',
    bottom: '6px',
    right: '45px',
  },
  summaryItem: {
    padding: '0 15px',
  },
  defaultTS: {
    backgroundColor: isDarkTheme(theme)
      ? theme.palette.info.dark
      : theme.palette.info.light + ' !important',
  },
  countBadge: {
    marginRight: '5px',
  },
  testCountBadge: {
    marginLeft: '5px',
  },
}));
